"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _themeProvider = require("@mmc/theme-provider");
var _commonCta = require("@mmc/common-cta");
var _formElements = require("@mmc/form-elements");
var _calculationForm = require("./calculation-form.prop-types");
var _calculationForm2 = require("./calculation-form.utils");
var _calculatorOptionsForm = _interopRequireDefault(require("./calculator-options-form.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CalculationOptionsForm = function CalculationOptionsForm(_ref) {
  var labels = _ref.labels,
    calculation = _ref.calculation,
    onSubmit = _ref.onSubmit,
    formData = _ref.formData;
  var theme = (0, _themeProvider.useTheme)();
  var defaultSelection = (0, _calculationForm2.getTaxesAndFeesSelection)(formData);
  var selection = (0, _react.useRef)(defaultSelection).current;
  var disclaimerStyle = (0, _clsx["default"])(_calculatorOptionsForm["default"].p, theme.smallType);
  var sectionStyle = (0, _clsx["default"])(theme['col-xs-12'], theme['col-md-6'], _calculatorOptionsForm["default"].section);
  var isRebateSelected = function isRebateSelected(code) {
    return (selection.rebates || []).includes(code);
  };
  var toggleRebate = function toggleRebate(code) {
    selection.rebates = (0, _xor2["default"])(selection.rebates, [code]);
  };
  var handleSalesAndFeesChange = function handleSalesAndFeesChange(e) {
    selection[e.target.name] = e.target.checked;
  };
  var handleSubmit = function handleSubmit() {
    onSubmit(selection);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorOptionsForm["default"].calculationOptionsForm
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx["default"])(_calculatorOptionsForm["default"].title, theme.headingTwo)
  }, labels.taxeFeeFilterPopupTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: sectionStyle
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx["default"])(theme.headingThree, _calculatorOptionsForm["default"].sectionTitle)
  }, labels.taxeFeesHeading), /*#__PURE__*/_react["default"].createElement(_formElements.InputGroup, {
    className: _calculatorOptionsForm["default"].inputGroup
  }, /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
    type: "checkbox",
    className: _calculatorOptionsForm["default"].inputLabel,
    name: "includeTax",
    defaultValue: formData.includeTax,
    onChange: handleSalesAndFeesChange,
    label: labels.includesSalesTaxLabel
  }), /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
    type: "checkbox",
    className: _calculatorOptionsForm["default"].inputLabel,
    name: "includeFee",
    defaultValue: formData.includeFee,
    onChange: handleSalesAndFeesChange,
    label: labels.includeFeesLabel
  }))), calculation.rebates.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: sectionStyle
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx["default"])(theme.headingThree, _calculatorOptionsForm["default"].sectionTitle)
  }, labels.rebatesTitle), calculation.rebates.map(function (rebate) {
    return /*#__PURE__*/_react["default"].createElement(_formElements.InputGroup, {
      key: rebate.name,
      className: _calculatorOptionsForm["default"].inputGroup
    }, /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
      type: "checkbox",
      className: _calculatorOptionsForm["default"].inputLabel,
      name: rebate.name,
      defaultValue: isRebateSelected(rebate.code),
      onChange: function onChange() {
        return toggleRebate(rebate.code);
      },
      label: rebate.label
    }));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-md-6'])
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    clickEvent: handleSubmit,
    classes: _calculatorOptionsForm["default"].applyAndCloseBtn,
    data: {
      label: labels.applyAndCloseBtn,
      priority: 'critical'
    }
  }))), /*#__PURE__*/_react["default"].createElement("p", {
    className: disclaimerStyle
  }, labels.copy));
};
var _default = exports["default"] = CalculationOptionsForm;